import React, { useState, useContext} from 'react'
import Logo from '../../Assets/logo.png'
import { Link, useNavigate} from 'react-router-dom'
import '../../css/Main/NavBar.css'
import { VscAccount } from "react-icons/vsc";
import { FaCartShopping } from "react-icons/fa6";
import { CartContext } from '../../Context/CartProvider';

const NavBar = () => {
  const {count} = useContext(CartContext);
  const navigate = useNavigate()
  const [isOpen, setIsOpen] = useState(false);
  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };
  return (
    <div className='nav-container'>
        <div className='nav-category-wrapper'>
          <div className='nav-category' onClick={() => navigate('/termekek/Egyszerhaszn%C3%A1latos%20term%C3%A9kek')}>
            Termékek
          </div>
        </div>
        <div className='nav-logo'>
              <img src={Logo} alt='logo' onClick={()=>navigate('/')}/>
              <a href="https://dcpfogaszatianyagok.hu">https://dcpfogaszatianyagok.hu</a>
        </div>
        <div className='nav-links'>
            <Link to={'/fiok'}><VscAccount /></Link>
            <Link to={'/kosar'} className='cart'><FaCartShopping />{count > 0 && (<p className='counter'>{count}</p>)}</Link>
            <Link to={'/rolunk'}>Rólunk</Link>
        </div>
    </div>
  )
}

export default NavBar